import axios from 'axios';
import API_HOST, { ApiKey } from '../api';

const mapLayerApi = function() {
  const api = {};
  const dataSource = 'API';

  const getUrlStub = function(type, config) {
    let url = `${API_HOST}/api/client/`;

    if (type === 'user') {
      url += `${config.userClientId}/user/${config.userId}`;
    }

    else url += config.clientId;

    return url;
  };


  /*
   * Get the list of all layers in the portal
   */
  api.getMapLayerGroups = function(config) {
    let url = `${getUrlStub('client', config)}/map-layer-group-list`;

    const request = axios.get(url);

    return request;
  };


  /*
   * Get a clients locations
   */
  api.getClientLocations = function(clientId, locationSetId, type) {
    const url = `${API_HOST}/api/client/${clientId}/location/${locationSetId}/map-geojson`;

    return axios.get(url, {
      params: {
        set: type,
      },
    });
  };


  /*
   * Get AccUcast observations
   */
  api.getAccucastObservations = function(limit, timestamp) {
    const url = `${API_HOST}/accucast/2/aesportalobs/obs_map.json`;

    return axios.get(url, {
      params: {
        limit,
        ts_min: timestamp,
      },
    });
  };


  /*
   * Get metadata for the radar layers
   */
  api.getRadarMetadata = function() {
    const url = `${API_HOST}/edsaes/radar/metadata/radars.json`;

    return axios.get(url);
  };


  /*
   * Get metadata for the radar layers
   */
  api.getRadarSiteMetadata = function(site) {
    const url = `${API_HOST}/edsaes/radar/metadata/${site}.json`;

    return axios.get(url);
  };


  /*
   * Get metadata for the satellite layers given the proper key
   */
  api.getSatelliteMetadata = function(key) {
    const url = `${API_HOST}/vortex/tiles/client/accuweather`;

    return axios.get(url, {
      params: {
        p: key,
        r: 'json'
      }
    });
  };

  api.getRadarProducts = function(bbox, zoom) {
    const url = 'https://api.accuweather.com/maps/v1/radar/globalSIR/preferred_box_products';

    return axios.get(url, {
      params: {
        // TODO: Find a better way to store this
        apikey: ApiKey,
        toplat: Math.ceil(bbox.getNorthEast().wrap().lat),
        bottomlat: Math.ceil(bbox.getSouthWest().wrap().lat),
        leftlon: Math.ceil(bbox.getSouthWest().wrap().lng),
        rightlon: Math.ceil(bbox.getNorthEast().wrap().lng),
        zoom: zoom === 6 ? 7 : zoom,
      },
    });
  };


  api.getRadarProductFrames = function(products) {
    const url = 'https://api.accuweather.com/maps/v1/radar/globalSIR/preferred_product_frames';

    return axios.get(url, {
      params: {
        // TODO: Find a better way to store this
        apikey: ApiKey,
        products: products.map(product => `${product.major}-${product.minor}`).toString(),
      },
    });
  };

  return api;
};

export default mapLayerApi();
